import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import Select from 'components/@common/Inputs/Select';
import useStore from 'store';
import { useField } from 'formik';
import { PRODUCT_FAMILY_OPTIONS } from '../../../utils/report-param-utils';

type Props = {
  name?: string;
} & React.ComponentProps<typeof Select>;

const ProductFamilyField: React.FC<Props> = ({ name = 'productFamilyCode', ...props }) => {
  const { t } = useTranslation('Reports');
  const [field, meta] = useField(name);
  const [{ userPrivilegesCache }] = useStore();

  const productFamilyOptions = PRODUCT_FAMILY_OPTIONS.filter(({ requiredPrivileges }) =>
    userPrivilegesCache.isPrivileged(requiredPrivileges)
  );

  return (
    <Select
      label={t('Select Product')}
      placeholder={t('Select Product')}
      size="small"
      inputProps={{
        'aria-label': t('Select Product')
      }}
      {...field}
      {...props}
      error={!!meta.error && meta.touched}
    >
      {productFamilyOptions.map(option => (
        <MenuItem key={`${option.value}-product-family-option`} value={option.value}>
          {t(option.value, { ns: 'ProductFamily' })}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ProductFamilyField;
